/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_SettingInputs */

const en_entity_setting = /** @type {(inputs: Entity_SettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setting`)
};

/** @type {(inputs: Entity_SettingInputs) => LocalizedString} */
const de_entity_setting = () => /** @type {LocalizedString} */ ('entity_setting')

/**
* | output |
* | --- |
* | "Setting" |
*
* @param {Entity_SettingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const entity_setting = /** @type {((inputs?: Entity_SettingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_SettingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_setting(inputs)
	return de_entity_setting(inputs)
});